import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';

// Importa los módulos de traducción

import operativeDashboardES from './es/operativeDashboard.json';
import operativeDashboardEN from './en/operativeDashboard.json';
import ordersEN from './en/orders.json';
import ordersES from './es/orders.json';

// Configuración de i18next
i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources: {
      es: {
        operativeDashboard: operativeDashboardES,
        orders: ordersES
      },
      en: {
        operativeDashboard: operativeDashboardEN,
        orders: ordersEN
      }
    },
    lng: localStorage.getItem('i18nextLng') || 'es',
    fallbackLng: 'es',
    ns: ['dashboard'],
    defaultNS: 'dashboard',
    interpolation: {
      escapeValue: false
    },
    react: {
      useSuspense: false
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    }
  });

export const changeLanguage = async (lang: string) => {
  try {
    await i18n.changeLanguage(lang);
    localStorage.setItem('i18nextLng', lang);
    return true;
  } catch (error) {
    console.error('Error changing language:', error);
    return false;
  }
};

export default i18n;